"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const form_1 = require("../form");
function useChangeHandler() {
    const dispatch = (0, react_redux_1.useDispatch)();
    return event => {
        if (!event.target)
            return;
        const target = event.target;
        const { value } = target;
        let currentValue = value;
        // if a checkbox, use a boolean of the checked
        if (target.type === 'checkbox')
            currentValue = target.checked;
        if (currentValue === 'false')
            currentValue = false;
        if (currentValue === 'true')
            currentValue = true;
        dispatch((0, form_1.handleOnChange)({ name: target.name, value: currentValue }));
    };
}
exports.default = useChangeHandler;
